import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { CreateStaffRequest } from '@/definitions/staff'
import { CreateStaff } from '@/services/StaffService'
import { MINIMUM_PROVISIONING_MS, withMinimumDuration } from '@/utils/minimumDuration'

interface CreateStaffVariables {
  orgId: string
  data: CreateStaffRequest
}

export const useCreateStaff = () => {
  const queryClient = useQueryClient()

  return useMutation({
    // The floor is held here rather than at the call site so the mutation's own
    // pending state covers the whole wait a caller is showing progress for.
    mutationFn: ({ orgId, data }: CreateStaffVariables) =>
      withMinimumDuration(CreateStaff(orgId, data), MINIMUM_PROVISIONING_MS),
    // The create-organization flow renders this failure inline because it has to
    // say what already survived, and because a refusal it can correct — a taken
    // username — is acted on there rather than dismissed as a toast.
    // Callers outside that flow should report the error themselves.
    meta: { suppressGlobalError: true },
    onSuccess: (_staff, { orgId }) => {
      queryClient.invalidateQueries({ queryKey: ['staff', orgId] })
    },
  })
}
